module.exports = __webpack_public_path__ + "static/img/4-bg.87d6444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/4-bg.png
// module id = hEml
// module chunks = 1